import { throwError as observableThrowError } from 'rxjs';
import { tap } from 'rxjs/operators';
import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiConfig } from './shared/services/api/config.api';
import { Router } from '@angular/router';


@Injectable()
export class CustomHttpInterceptor implements HttpInterceptor {
  token: any;

  settings = {
    url: 'api/ack', // the URL to which the CSRF call has to be made to get the token
    csrfHttpType: 'get', // the HTTP method type which is used for making the CSRF token call
    maxRetries: 3, // number of retires allowed for forbidden requests
    csrfTokenHeader: 'X-PMI-CST',
    httpTypes: ['GET', 'HEAD', 'PUT', 'POST', 'DELETE'] // default allowed HTTP types
  };

  constructor(private router: Router) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    this.token = this.getTokenData();

    request = request.clone({headers: request.headers.set('X-PMI-CST', this.token)});

    return next.handle(request).pipe(
      tap((event) => {
          if (event instanceof HttpResponse) {
            // do stuff with response if you want
          }
        },
        (err: any) => {
          if (err instanceof HttpErrorResponse) {
            switch (err.status) {
              case 400:
                this.router.navigate(['login']);
                return observableThrowError('Bad Request');
              case 401:
                this.router.navigate(['login']);
                return observableThrowError('Unauthorized');
              case 403:
                this.token = this.getTokenData();
                this.router.navigate(['login']);
                return observableThrowError('Forbidden');
              case 404:
                this.router.navigate(['maintenance']);
                return observableThrowError('Not Found');
              case 500:
                return observableThrowError('Internal Server Error');
              case 502:
                this.router.navigate(['maintenance']);
                return observableThrowError('Bad Gateway');
              case 503:
                this.router.navigate(['maintenance']);
                return observableThrowError('Service Unavailable');
              case 504:
                this.router.navigate(['maintenance']);
                return observableThrowError('Gateway Timeout');
              default:
                this.token = this.getTokenData();
                return observableThrowError('Undefined error.');
            }
          }
        }));
  }

  getTokenData() {
    if (window.location.hash.search('maintenance') > 0) {
      return '';
    }
    const xhr = new XMLHttpRequest();
    xhr.open(this.settings.csrfHttpType, ApiConfig.baseURL + this.settings.url, false);
    xhr.send();

    if (xhr.status === 404 || xhr.status === 502 || xhr.status === 503 || xhr.status === 504) {
      this.router.navigate(['maintenance']);
      return '';
    }
    return xhr.getResponseHeader(this.settings.csrfTokenHeader);
  }
}
